import { defaultSerializeQueryArgs } from '@reduxjs/toolkit/query'
import { ApiResponseSerializer } from '@v2/commons/interface/ApiResponseSerializer'
import { rootApi } from '@v2/store/api/rootApi'

import { BenefitLinkDto } from 'src/api/generated'

export const benefitApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getBenefitsByAbcs: builder.query<
      ApiResponseSerializer<BenefitLinkDto>,
      {
        params: {
          abcIds: string[] | string
          offset?: number
          limit?: number
          search?: string
        }
      }
    >({
      query: ({ params }) => ({
        url: '/benefits',
        method: 'GET',
        params,
      }),
      serializeQueryArgs: ({ endpointName, queryArgs, endpointDefinition }) => {
        const { offset, ...rest } = queryArgs.params
        return defaultSerializeQueryArgs({
          endpointName,
          endpointDefinition,
          queryArgs: rest,
        })
      },
      merge: (currentCache, newItems, { arg }) => {
        if (arg.params.offset === 0 || !!arg.params.search) {
          return newItems
        }
        return {
          ...newItems,
          records: [...(currentCache?.records || []), ...newItems.records],
        }
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.params.offset !== previousArg?.params.offset
      },
    }),
  }),
})

export const { useGetBenefitsByAbcsQuery } = benefitApi
